<template>
  <div class="video-player">
    <AspectRatio :ratio="16 / 9">
      <video
        ref="videoRef"
        :key="options.src"
        class="absolute left-0 top-0 w-full h-full rounded-2xl border mx-auto aspect-video bg-black"
        :class="{ 'border-0 rounded-none': borderless }"
        :controls="hasStarted || $slots.default === undefined"
        playsInline
        :poster="options.poster || undefined"
        controlslist="nodownload"
        :autoplay="false"
        @pause="$emit('on-pause', $event)"
        @play="$emit('on-play', $event)"
      >
        Your device does not support HTML5 video.
        <a :href="options.src">Download video here.</a>
        <source :src="options.src" :type="options.type" />
      </video>
      <slot :handle-play-click="handlePlayClick" :has-started="hasStarted" />
    </AspectRatio>
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import type { PlayerOptions } from '~~/entities/video-player'

// NOTE: July 27, 2023 - Due to a strange issue with Safari, when entering and exiting full screen mode of a video whose parent element has display: flex,
// the video element will be lost/disappear from the DOM. As a result, any parent component wrapping this component should use display: grid
defineProps({
  options: {
    type: Object as PropType<Partial<PlayerOptions>>,
    default: () => ({}),
  },
  borderless: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['on-play', 'on-pause'])

const hasStarted = ref(false)
const videoRef = ref<HTMLVideoElement | null>(null)

function handlePlayClick() {
  if (videoRef.value) {
    hasStarted.value = true
    videoRef.value.play()
  }
}
</script>

<style scoped>
video {
  max-height: inherit;

  &.hide-controls {
    &::-webkit-media-controls-enclosure {
      display: none !important;
    }
  }
}
</style>
